export const makeTraceHttpRequestHeaders = (
    traceId: string,
    sampled: string,
    spanId: string
) => ({
    "X-B3-TraceId": traceId,
    "X-B3-Sampled": sampled,
    "X-B3-SpanId": spanId
});
